import type { Team } from '@/types/responses/Player';

export type User = {
  id?: number;
  full_name: string;
  first_name: string;
  last_name: string;
  description?: string;
  birthdate: string;
  gender?: string;
  email: string;
  phone_number?: string;
  created_at: string;
  updated_at: string;
  blocked_at?: string;
  onboarded_at?: string;
  primary_username: string;
  email_verified: boolean;
  phone_number_verified: false;
  verified: boolean;
  avatar_permanent_url: string;
  avatar_permanent_thumb_url: string;
  mine: boolean;
  avatar: UserAvatar;
  onboarding: UserAccountOnboarding;
  account: UserAccount;
  role: string;
  player_availability: boolean;
  player_access: PlayerAccess;
  access_request: AccessRequest;
  specializations: Array<Specialization>;
  clubOwner?: Club;
  team?: Team;
  is_under_18?: boolean;
  checked_policy?: number;
};

export type AccessRequest = {
  id: number;
  approved_at: string | null;
  requested_at: string | null; // ISO datetime string
  rejected_at: string | null;
  status: string;
};

export type PlayerAccess = {
  player_id: number;
  health_professional_id: number;
  created_at: string; // ISO datetime string
  updated_at: string; // ISO datetime string
  rejected_at: string | null;
  accepted_at: string | null;
};

export type Specialization = {
  id: string;
  name: string;
};

export type SocialProvider = {
  token: string;
  provider: string;
};
export type UserAccount = {
  first_name: string;
  last_name: string;
  birthdate: string;
};

export type LoginForm = {
  mobile: string;
};
export type UserAccountOnboarding = {
  skipped_complete_profile: boolean;
  skipped_avatar: boolean;
};

export type UserAvatar = {
  id: number;
  name: string;
  file_name: string;
  collection_name: string;
  mime_type: string;
  size: number;
  created_at: string;
  url: string;
  thumb_url: string;
  responsive_url: string;
};

export type LoginResponse = {
  access_token: string;
  user: User;
};

export type RegisterForm = {
  email: string;
  password: string;
  password_confirmation: string;
};

export type RegisterResponse = {
  access_token: string;
  user: User;
};

export type CompleteProfileForm = {
  first_name: string;
  last_name: string;
  birthdate: string;
};

export type EmailForm = {
  email: string;
};

export type ForgotPasswordEmailForm = {
  username: string;
};
export type ForgotPasswordVerifyForm = {
  username: string;
  token: string;
};
export type ForgotPasswordResetPasswordForm = {
  username: string;
  token: string;
  password: string;
  password_confirmation: string;
};

export type VerifyOTPForm = {
  otp: string;
};

export type VerifyChangeEmailForm = {
  token: string;
};

export type ChangePasswordForm = {
  old_password: string;
  new_password: string;
  new_password_confirmation: string;
};

export type VerifyChangePasswordForm = {
  password: string;
};

export type VerifyChangePasswordResponse = {
  token: string;
};

export type Club = {
  id: number;
  name: string;
  is_active: boolean;
  avatar?: UserAvatar;
};

// Role constants
export const USER_ROLES = {
  PLAYER: 'PLAYER',
  EXTERNAL_HEALTH_PROFESSIONAL: 'EXTERNAL_HEALTH_PROFESSIONAL',
  INTERNAL_HEALTH_PROFESSIONAL: 'INTERNAL_HEALTH_PROFESSIONAL',
  HEALTH_OFFICER: 'HEALTH_OFFICER',
} as const;
